<template>
  <div class="container-fluid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutContainer',
};
</script>
